import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  username: string
  email: string
  isAdmin: boolean
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  login: (email: string, password: string) => Promise<void>
  register: (username: string, email: string, password: string) => Promise<void>
  logout: () => void
}

// Helper to get stored users
const getUsers = (): any[] => {
  try {
    return JSON.parse(localStorage.getItem('oded-users') || '[]')
  } catch { return [] }
}

const saveUsers = (users: any[]) => {
  localStorage.setItem('oded-users', JSON.stringify(users))
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      login: async (email, password) => {
        const users = getUsers()
        const user = users.find((u: any) => u.email === email && u.password === password)
        if (!user) {
          throw new Error('Invalid credentials')
        }
        const token = 'local-' + user.id
        set({ user: { id: user.id, username: user.username, email: user.email, isAdmin: user.isAdmin }, token, isAuthenticated: true })
      },

      register: async (username, email, password) => {
        const users = getUsers()
        if (users.find((u: any) => u.email === email || u.username === username)) {
          throw new Error('Username or email already exists')
        }
        const id = 'u-' + Date.now()
        const isAdmin = users.length === 0 // First user is admin
        const newUser = { id, username, email, password, isAdmin, country: 'US' }
        users.push(newUser)
        saveUsers(users)
        const token = 'local-' + id
        set({ user: { id, username, email, isAdmin }, token, isAuthenticated: true })
      },

      logout: () => {
        set({ user: null, token: null, isAuthenticated: false })
      },
    }),
    { name: 'oded-auth' }
  )
)
